export function isObjectEmpty(obj: any): boolean {
    if (obj === null || obj === undefined) {
        return true;
    }
    // null and undefined are already checked before
    if (obj instanceof Date) {
        return false;
    }
    // this check needs to be before the object check, because an empty array is a not empty object
    if (Array.isArray(obj)) {
        return obj.every((item) => isObjectEmpty(item));
    }

    if (typeof obj === 'object') {
        for (const key in obj) {
            if (!isObjectEmpty(obj[key])) {
                return false;
            }
        }
        return true;
    }

    if (typeof obj === 'string') {
        return obj.trim() === '';
    }
    return false;
}
